export default "__VITE_ASSET__BRs5QLBR__"